export const createConnectionQuery = ({
  language,
  token,
  cid,
  tokenExpiresAt,
  tokenReceivedAt,
  expired,
}: ConnectionParams) => {
  let timestamp = 'debug';

  try {
    // TODO: temporary decision for debug purposes. Remove in future
    timestamp = btoa(
      JSON.stringify({
        exp: new Date(tokenExpiresAt).toISOString(),
        expired: expired,
        now: new Date().toISOString(),
        rcv: new Date(tokenReceivedAt).toISOString(),
      }),
    )
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  } catch (error: any) {
    // bad luck
    timestamp = error.message;
  }

  const query = new URLSearchParams({
    cid,
    format: 'short',
    lang: language,
    timestamp,
    token: token,
  });

  return query;
};

interface ConnectionParams {
  language: string;
  token: string;
  cid: string;
  tokenExpiresAt: number;
  tokenReceivedAt: number;
  expired: boolean;
}
